import { curry } from 'ramda';

/**
 * Open file dialog.
 */
const openFileDialog = curry((cb: (files: FileList) => void, id: string, accept: string, multiple: boolean = true) => {
  // Remove element with this id.
  // When the file input is appended to the document but no file is selected, no event is fired
  // and the element cannot be removed (see below)
  document.querySelectorAll(`#${id}`).forEach((element) => {
    element.remove();
  });

  const fileSelector = document.createElement('input');
  fileSelector.dataset.testId = id;
  fileSelector.id = id;
  fileSelector.setAttribute('type', 'file');
  fileSelector.setAttribute('style', 'display: none');

  if (multiple) fileSelector.setAttribute('multiple', 'multiple');
  if (accept) fileSelector.setAttribute('accept', accept);

  fileSelector.addEventListener(
    'change',
    (event) => {
      fileSelector.remove();

      cb((event.target as HTMLInputElement).files);
    },
    { once: true }
  );

  if (TESTING_UTIL) {
    // Add the element to the DOM tree so it can be manipulated by automated tests
    document.body.appendChild(fileSelector);
  }

  // Open the dialog
  fileSelector.click();
});

export default openFileDialog;
